import { get, isEqual } from "lodash-es";
import { INJECT_UICORE_BUS } from "../../../lib/utils/consts";
const notSelected = Symbol(); // 这只是一个占位符，保持原样就行
/**
 * @param this 组件本体
 * @param expression 要监测的值，比如
 *   - 直接从当前组件实例取 `() => this.modelType`
 *   - 从 Layout JSON 取: `"props.modelType"` - 注意在默认值情况下，**有可能** 会取到 `undefined`
 *   - 或者函数方式 `layout => layout.props?.modelType`
 * @param mutator 如何修改组件的逻辑。参数1 是组件Layout，参数2 是监测的值
 * @example
 *   ```js
 *   // 在组件的 created() 生命周期里面
 *
 *   // 当用户修改了属性 sourceName 时，自动联动修改 sourceTitle
 *   this.ucObserveInDesigner(
 *     () => this.sourceName,
 *     (comp, sourceName) => {
 *       // 此处 comp 是组件的 Layout JSON，UICore 为节约存储空间，其可能没有 props 对象
 *       // 所以这里需要手动补全
 *       if (!comp.props) comp.props = {};
 *
 *       // 以下才是联动逻辑
 *       comp.props.sourceTitle = sourceName;
 *     }
 *   );
 *   ```
 */
export function observeInDesigner(expression, mutator) {
  var _this$INJECT_UICORE_B;
  const designer = (_this$INJECT_UICORE_B = this[INJECT_UICORE_BUS]) === null || _this$INJECT_UICORE_B === void 0 ? void 0 : _this$INJECT_UICORE_B.designer;
  if (!designer) return; // 非编辑模式
  const valGetter = typeof expression === 'function' ? () => expression.call(this, designer.activeComp) : () => get(designer.activeComp, expression);
  this.$watch(() => this.$attrs['data-uc-selected'] ? valGetter() : notSelected, async (n, o) => {
    // 避免误触发
    if (n === notSelected || o === notSelected) return;
    if (isEqual(n, o)) return;
    // 现在 xxxxxx 确实被修改了
    // 条件成立，使用 modifyActiveComp 修改属性即可
    await designer.modifyActiveComp(comp => mutator(comp, n));
  });
}